import * as React from 'react';
import { Divider, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UploadImageButton from 'modules/common/inputs/UploadImageButton';
import { Upload } from '@mui/icons-material';

export default function UploadImageDialog({
    open,
    onClose,
    handleChange,
    onConfirm,
    value
}) {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={(e) => e.preventDefault()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
        >

            <DialogTitle id="alert-dialog-title">
                {t("Upload image")}
            </DialogTitle>
            <Divider />
            <DialogContent>
                <UploadImageButton
                    startIcon={<Upload />}
                    title={t('Upload')}
                    onChange={handleChange}
                    variant="outlined"
                    name='image'
                    sx={{ fontWeight: 'bold', textAlign: "center", textTransform: "none" }}
                />
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button
                    sx={{ textTransform: "none", }}
                    variant='contained'
                    onClick={onClose}
                >
                    {t("Close")}
                </Button>
                <Button
                    sx={{ textTransform: "none", mx: '4px' }}
                    variant='contained'
                    onClick={onConfirm}
                    autoFocus
                    disabled={!value}
                >
                    {t("Confirm")}
                </Button>
            </DialogActions>
        </Dialog >
    );
}
